import React, { useState, memo, useEffect, createRef, forwardRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ForwardDiv = forwardRef((props, ref) => <div ref={ref} {...props} />);
const SelectWarper = styled(ForwardDiv)`
    width: ${props => props.width};
    position: relative;
    display: inline-block;
    z-index: 5;
`;
//------------------------------------------
const Selected = styled.div`
    color: ${props => props.textColor};
    background-color: ${(props) => props.color};
    cursor: pointer;
    user-select: none;
    &::after{
        position: absolute;
        content: '';
        top: ${(props) => props.open ? '7px' : '14px'};
        right: 10px;
        width: 0;
        height: 0;
        border: ${(props) => props.withDrop ? '6px' : '0'} solid transparent;
        border-color: ${(props) => props.open ? 'transparent transparent #fff transparent' : '#fff transparent transparent transparent'};
    }
`;
Selected.defaultProps = {
    withDrop: true
};
Selected.propTypes = {
    withImage: PropTypes.bool.isRequired,
    color: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    textColor: PropTypes.string.isRequired,
    withDrop: PropTypes.bool
};
//--------------------------------------------
const SelectOptionsList = styled.div`
    display: ${(props) => props.open ? 'unset' : 'none'};
    background-color: ${(props) => props.color};
    color: ${(props) => props.textColor};
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 99;
    font-size: 13px;
`;
SelectOptionsList.propTypes = {
    color: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    textColor: PropTypes.string.isRequired
};
//-----------------------------------------------
const SelectOptions = styled.div`
    position: relative;
    color: ${(props) => props.textColor};
    padding: 8px 16px 8px ${(props) => props.withImage ? '43px;' : '16px'};
    border: 1px solid transparent;
    border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
    cursor: pointer;
    user-select: none;
    background-color: ${(props) => props.active ? 'rgba(255,255,255,0.3)' : 'unset'};
    &:hover{
        background-color: rgba(255,255,255,0.3)
    }
`;
SelectOptions.propTypes = {
    withImage: PropTypes.bool.isRequired,
    textColor: PropTypes.string.isRequired,
    active: PropTypes.bool
};
SelectOptions.defaultProps = {
    active: false
};
export const Select = memo((props) => {
    // eslint-disable-next-line no-unused-vars
    const { data, value, name, onChange, required, color, textColor, width, className, optionsClassname, ...rest } = props;
    let referenceWarper = createRef();
    const [currentIndex, setIndex] = useState(data.findIndex(item => item.value === value));
    const [isOpen, setIsOpen] = useState(false);
    function selectHandler (index) {
        onChange(name, data[index].value);
        setIndex(index);
        setIsOpen(false);
    }
    function mouseDownHandler (e) {
        if (referenceWarper.current.contains(e.target)) {
            return;
        }
        isOpen && setIsOpen(false);
    }
    useEffect(() => {
        document.addEventListener('mousedown', mouseDownHandler, false);
        return () => {
            document.removeEventListener('mousedown', mouseDownHandler, false);
        };
    });
    const currentImage = (currentIndex >= 0) ? data[currentIndex].image : false;
    const currentText = (currentIndex >= 0) ? data[currentIndex].text : false;
    const handlerClick = useCallback(() => setIsOpen(!isOpen), [isOpen]);
    return (
        <SelectWarper ref={referenceWarper} width={width} className={`${className || ''} ${isOpen ? 'dropdown-active' : ''}`} {...rest}>
            <Selected color={color} withDrop={data.length !== 1} className='dropdown-flag' textColor={textColor} open={isOpen} withImage={Boolean(currentImage)} onClick={handlerClick}>
                {currentImage && <span className={`flag-view-m icon-${currentImage}`} />}
                <p className="dropdown-text">{currentText || "Select"}</p>
            </Selected>
            <SelectOptionsList key={currentIndex} color={color} textColor={textColor} open={isOpen} >
                {
                    // eslint-disable-next-line react/jsx-no-bind
                    data.map((item, index) => <SelectOptions className={optionsClassname} textColor={textColor} hidden={index === currentIndex} key={item.value} withImage={Boolean(item.image)} onClick={selectHandler.bind(this, index)}>
                        {Boolean(item.image) && <span className={`flag-view-m icon-${item.image}`} />}
                        {item.text}
                    </SelectOptions>)
                }
            </SelectOptionsList>
        </SelectWarper>
    );
});
Select.defaultProps = {
    color: 'var(--heroColor)',
    textColor: `var(--textColor)`,
};
Select.propTypes = {
    color: PropTypes.string,
    textColor: PropTypes.string,
    width: PropTypes.string,
    data: PropTypes.array.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};